export * from './baMsgCenter.component';



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/components/baMsgCenter/index.ts